export default __webpack_public_path__ + "static/hero-l5-bg-course1-d135efd85f6412c30fa6a542a047a31f.png";